<template>
  <el-container id="customer-group">
    <el-aside width="140px">
      <el-tabs tab-position="left" v-model="acviteGroup" @tab-click="groupChange">
        <el-tab-pane label="New Group" name="0"></el-tab-pane>
        <el-tab-pane v-for="item in groupList" :key="item.id" :label="item.name" :name="item.id.toString()"></el-tab-pane>
      </el-tabs>
    </el-aside>
    <el-main class="main">
      <div class="title">Group Information</div>
      <table>
        <tr>
          <td style="width:160px;vertical-align:top;text-align:right;padding-right:4px;">Group Name:</td>
          <td>
            <el-input v-model="group.name" style="width:600px"></el-input>
          </td>
        </tr>
        <tr>
          <td style="width:160px;vertical-align:top;text-align:right;padding-right:4px;">Group Description:</td>
          <td>
            <el-input v-model="group.description" type="textarea" :rows="4" style="width:600px"></el-input>
          </td>
        </tr>
      </table>
      <hr/>
      <div flex>
        <div style="width:500px;padding-right:10px;">
          <div class="title">Group Companies</div>
          <table class="cystron-table">
            <tr>
              <th>company name</th>
              <th>country</th>
              <th>&nbsp;</th>
            </tr>
            <tr v-for="(item, index) in companyList" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.country }}</td>
              <td><el-button type="text" @click="removeCompany(index)">Remove</el-button></td>
            </tr>
            <tr v-if="companyList.length === 0">
              <td colspan="2" style="text-align:center;padding:40px 0;">No Companies.</td>
            </tr>
          </table>
        </div>
        <div style="width:500px;padding-left:10px;">
          <div class="title">Add to Group</div>
          <div style="margin:6px 0;">
            Search:
            <el-input v-model="query" style="width:160px" placeholder="company name"></el-input>&nbsp;
            <el-select v-model="sales_id" style="width:130px;" :disabled="user.role_id > 2">
              <el-option label="ALL" :value="null"></el-option>
              <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
            </el-select>&nbsp;&nbsp;
            <el-button type="success" style="margin-left:10px" @click="searchCompany">Search</el-button>
          </div>
          <table class="cystron-table">
            <tr>
              <th style="width:300px">company name</th>
              <th>sales</th>
              <th>country</th>
              <th>&nbsp;</th>
            </tr>
            <tr v-for="item in queryList" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.sales_name }}</td>
              <td>{{ item.country }}</td>
              <td><el-button type="text" @click="addCompany(item)">Add</el-button></td>
            </tr>
            <tr v-if="queryList.length === 0">
              <td colspan="2" style="text-align:center;padding:40px 0;">No Result.</td>
            </tr>
          </table>
        </div>
      </div>
      <hr/>
      <div style="text-align:center;">
        <el-button type="primary" :disabled="!group.name" @click="save">Save</el-button>
        <el-button type="danger" v-if="group.id > 0" @click="delGroup">Delete</el-button>
      </div>
      <hr/>
      <div v-if="group.create_oper_name">Create by {{ group.create_oper_name }} at {{ group.create_time }}</div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      group: {
        id: 0,
        name: '',
        description: ''
      },
      groupList: [],
      companyList: [],
      queryList: [],
      query: '',
      sales_id: this.$store.state.user.id,
      acviteGroup: '0'
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    salesList () {
      return this.$store.state.select.sales
    }
  },
  mounted () {
    this.fetch()
    this.$store.dispatch('fetchSelect', 'sales')
  },
  methods: {
    fetch () {
      this.$http.get('/dbapi/company_group_list').then(data => {
        this.groupList = data.list
      })
    },
    fetchCompany () {
      if (this.group.id === 0) {
        this.companyList = []
        return
      }
      this.$http.get('/dbapi/company_group_companies?group_id=' + this.group.id).then(data => {
        this.companyList = data.list
      })
    },
    searchCompany () {
      this.$http.get('/dbapi/company_list', {
        params: {
          start: 0,
          limit: 10,
          query: this.query,
          sales_id: this.sales_id
        }
      }).then(data => {
        this.queryList = data.list
      })
    },
    addCompany (company) {
      this.companyList.push(company)
    },
    removeCompany (index) {
      this.companyList.splice(index, 1)
    },
    groupChange (val) {
      if (val.name === '0') {
        this.group = {
          id: 0,
          name: '',
          description: ''
        }
      } else {
        this.group = this.groupList.filter(r => r.id === parseInt(val.name))[0]
      }
      this.fetchCompany()
    },
    newGroup () {
      this.group = {
        id: 0,
        name: '',
        description: ''
      }
      this.fetchCompany()
    },
    save () {
      if (this.companyList.length === 0) {
        this.$message({
          type: 'error',
          message: '请添加客户'
        })
        return
      }
      if (this.group.id === 0) {
        this.$http.post('/dbapi/company_group_insert', {
          name: this.group.name,
          description: this.group.description,
          company_ids: this.companyList.map(r => r.id)
        }).then(result => {
          this.fetch()
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          this.acviteGroup = '0'
          this.groupChange({ name: '0'})
        })
      } else {
        this.$http.post('/dbapi/company_group_update', {
          id: this.group.id,
          name: this.group.name,
          description: this.group.description,
          company_ids: this.companyList.map(r => r.id)
        }).then(result => {
          this.$message({
            type: 'success',
            message: '保存成功'
          })
        })
      }
    },
    delGroup () {
      this.$confirm('确定要删除这个Group吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/company_group_del', { id: this.group.id }).then(result => {
          this.fetch()
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.acviteGroup = '0'
          this.groupChange({ name: '0'})
        })
      })
    }
  }
}
</script>

<style lang="scss">
#customer-group {
  background-color: #fff;
  .title {
    font-weight: bold;
    background-color: #ddd;
    padding: 4px;
    margin-bottom: 10px;
  }
}
</style>
